import React from "react";
import { MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import type { ConversationListItem as ConversationData } from "../../types/conversation";
import { formatRelativeTime, getMessagePreview } from "../../utils/conversation";

interface ConversationListItemProps {
  conversation: ConversationData;
  isActive: boolean;
  onClick: () => void;
}

export function ConversationListItem({
  conversation,
  isActive,
  onClick
}: ConversationListItemProps) {
  return (
    <button
      onClick={onClick}
      data-slot="conversation-item"
      className={cn(
        "w-full text-left rounded-lg p-3 transition-all duration-200",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        isActive
          ? "bg-gray-200 dark:bg-gray-700"
          : "hover:bg-accent hover:text-accent-foreground"
      )}
    >
      <div className="flex items-start gap-2">
        <MessageSquare className="h-4 w-4 mt-0.5 flex-shrink-0 text-muted-foreground" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h3 className={cn("text-sm font-medium truncate", isActive && "font-bold")}>
              {conversation.title}
            </h3>
            {conversation.messageCount > 0 && (
              <Badge variant="secondary" className="text-xs px-1.5 py-0">
                {conversation.messageCount}
              </Badge>
            )}
          </div>

          {conversation.lastMessage && (
            <p className="text-xs text-muted-foreground truncate mt-1">
              {getMessagePreview(conversation.lastMessage.content, 60)}
            </p>
          )}

          <p className="text-xs text-muted-foreground mt-1">
            {formatRelativeTime(conversation.lastMessageAt || conversation.createdAt)}
          </p>
        </div>
      </div>
    </button>
  );
}
